import { ILayoutPlan } from "@types"
import { protectedApi } from "store/Api"

const layoutPlan = protectedApi.injectEndpoints({


    endpoints: (builder) => ({
        layoutPlan: builder.query<ILayoutPlan, void>({
            query: () => {
                return {
                    method: "GET",
                    url: `settings/layout_plan`,
                }
            },
        }),
    }),
})


export const { useLayoutPlanQuery } = layoutPlan
